import React, { useEffect } from "react";

const CGV: React.FC = () => {
  const title = "Conditions Générales de Vente (CGV) | Mon Copieur";
  const description = "CGV de Mon Copieur.";

  useEffect(() => {
    document.title = title;
    let metaTag = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.name = "description";
      document.head.appendChild(metaTag);
    }
    metaTag.content = description;
  }, []);

  return (
    <>
      <header className="border-b border-border bg-secondary/40">
        <div className="container mx-auto px-4 py-10">
          <h1 className="text-3xl font-semibold">Conditions Générales de Vente</h1>
        </div>
      </header>

      <article className="prose prose-neutral max-w-none container mx-auto px-4 py-8">
        <section>
          <h2>1. Dispositions générales</h2>
          <p>
            Les présentes conditions générales de vente s'appliquent à toutes les commandes passées
            sur le site www.moncopieur.ma exploité par la société MON COPIEUR.
          </p>
        </section>

        <section>
          <h2>2. Prix et paiement</h2>
          <p>
            Les prix indiqués sont en dirhams marocains (MAD) et incluent la TVA. Le paiement peut
            s'effectuer par carte bancaire, virement ou espèces à la livraison.
          </p>
        </section>

        <section>
          <h2>3. Livraison</h2>
          <p>
            Les délais de livraison sont donnés à titre indicatif. La livraison s'effectue à l'adresse
            indiquée par le client lors de la commande.
          </p>
        </section>

        <section>
          <h2>4. Droit de rétractation</h2>
          <p>
            Conformément à la législation en vigueur, le client dispose d'un délai de rétractation
            pour les achats effectués en ligne, sauf exceptions légales.
          </p>
        </section>
      </article>
    </>
  );
};

export default CGV;